interface SendNotesDealProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const SendNotesDeal = ({
    fill = '#1094F7',
    height = 20,
    width = 20,
}: SendNotesDealProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
            fill={fill}
        />
        <path
            d="M9.99996 7.00014V14.0002M13.5 9.49997C13.5 9.49997 10.9223 6.00001 9.99997 6C9.07766 5.99999 6.5 9.5 6.5 9.5"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
